import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(duration);
dayjs.extend(advancedFormat);

export const formatDate = (dateString: string): string =>
  dayjs(dateString).format('ddd, Do MMM, YYYY (HH:mm)');
